import React from "react";
import { Box, Flex, Text, Icon, Collapse } from "@chakra-ui/react";
import { FiChevronDown } from "react-icons/fi";

const slugify = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const ActivityAccordion = ({
  title,
  count,
  icon: IconComponent,
  isOpen,
  onToggle,
  children,
  sectionId,
}) => {
  const id = sectionId || slugify(title);
  return (
    <Box data-testid={`agenda-section-${id}`}>
      <Flex
        align="center"
        justify="space-between"
        py={2}
        px={1}
        cursor="pointer"
        onClick={onToggle}
        _hover={{ bg: "gray.50" }}
        borderRadius="md"
        transition="background 0.2s"
        data-testid={`agenda-section-${id}-toggle`}
      >
        <Flex align="center" gap={1}>
          {IconComponent && (
            <Box
              w={5}
              h={5}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <IconComponent />
            </Box>
          )}
          <Text
            fontSize="16px"
            fontWeight={400}
            color="#433358"
            lineHeight="1.5em"
            letterSpacing="-2%"
          >
            {title} [{count}]
          </Text>
        </Flex>
        <Icon
          as={FiChevronDown}
          w={5}
          h={5}
          color="#433358"
          transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
          transition="transform 0.2s"
        />
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Box>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default ActivityAccordion;
